import React from 'react'
import ResumeCheckbox from '../ResumeCheckbox'
import { connect } from "react-redux";
import { handleWorkPrivacy } from '../../../../services/actions/actions';

function ContentWorkExp({ workDetail,handleWorkPrivacy }) {
    return (
        <>
            <div>
                {workDetail.map((data, idx) => {
                    const {entries,isHidden}  = data;
                    return <div key={idx} className='border-b border-gray-300 py-2'>
                        <div>
                            <span className='manpro font-semibold'>{entries.work_title} - </span>
                            <span className='text-sm italic manpro text-gray-600 font-light'>{entries.work_company}</span>
                        </div>
                        <div>
                            <ResumeCheckbox value={isHidden ? 'noshow' : 'show'} onChange={(e) => handleWorkPrivacy({selectedId: idx, value: e.target.value})}/>
                        </div>
                    </div>
                })}
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToState = (dispatch) => {
    return {
        handleWorkPrivacy: (value) => {
            dispatch(handleWorkPrivacy(value))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToState)(ContentWorkExp)

